module.exports = __webpack_public_path__ + "media/bg_sound.46f69549.ogg";